<div class="tnimm-container">
	<div class="content-wrapper">
		<div class="glass-card">
			<div class="accent-glow"></div>

			<div class="content-body">
				<div class="status-badge">
					<span class="pulse"></span>
					UNDER PROGRESS
				</div>

				<h1 class="main-title">TNIMM 2.0</h1>
				<h2 class="sub-title">The Future of Incubation is Arriving</h2>

				<p class="descriptions">
					We're upgrading our platform to provide a more seamless, powerful, and data-driven experience
					for the startup ecosystem. TNIMM 2.0 is currently under heavy development
					to bring you advanced analytics, better tracking, and enhanced collaboration tools.
				</p>

				<div class="footer-note">
					Stay tuned for more updates.
				</div>
			</div>
		</div>
	</div>
</div>